import { render } from "./BudgetCategories.vue?vue&type=template&id=32c16423&ts=true"
import script from "./BudgetCategories.vue?vue&type=script&lang=ts"
export * from "./BudgetCategories.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__